import React from 'react';
import MUITextField from '@mui/material/TextField';

type DecimalInputProps = {
    name: string;
    label: string;
    value?: string | number | null;
};

const DecimalInput = (props: DecimalInputProps) => {
    const { label, value, name, ...rest } = props;

    return <MUITextField type="number" label={label} value={value} name={name} {...rest} />;
};

export default DecimalInput;
